import { getMinAgeByCountry } from '@/helpers/conf';

export const days = Array.apply(null, Array(31)).map((_, index) => {
  const day = index + 1;
  const dayFull = day > 9 ? `${day}` : `0${day}`;

  return {
    name: dayFull,
    value: dayFull,
  };
});

export const months = Array.apply(null, Array(12)).map((_, index) => {
  const month = index + 1;

  return {
    name: month,
    value: (month > 9 ? `${month}` : `0${month}`).toString(),
  };
});

export const getYears = (countryCode?: string) => {
  const currentFullYear = new Date().getFullYear();
  const decrement = getMinAgeByCountry(countryCode);
  const currentYear = currentFullYear - decrement;

  return Array.apply(null, Array(100)).map((_, index) => {
    const year = (Number(currentYear) - index).toString();

    return {
      name: year,
      value: year,
    };
  });
};
